// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2HSGo","search":"Settings_search__36oG_","filter":"Settings_filter__1lhlo"};